import { post } from "../services/services";
import { ApiURL } from "../services/apiConstants";

export const logout = () => {
  const FORM_DATA = new FormData();
  post(ApiURL.logout, FORM_DATA)
    .then((res) => {
      if (res?.status === true) {
        localStorage.clear();
        window.location = "/";
      } else {
        localStorage.clear();
        window.location = "/";
      }
    })
    .catch((error) => {
      console.error("Logout failed: ", error);
      localStorage.clear();
      window.location = "/";
    });
};
